@if (!isMobileView) {
  <p-menubar id="app-menubar" [model]="navMenuItems" styleClass="app-menubar"></p-menubar>
}
@if (desktopMenuOpen && !isMobileView) {
  <button type="button" class="app-menubar-close" (click)="closeDesktopMenu()"
    aria-label="Fechar menu">
    <i class="pi pi-times"></i>
  </button>
}
@if (desktopMenuOpen && !isMobileView) {
  <button type="button" class="app-menubar-backdrop" [style.top.px]="desktopBackdropTop"
  (click)="closeDesktopMenu()" (keydown.enter)="closeDesktopMenu()" (keydown.space)="closeDesktopMenu()" aria-label="Fechar menu"></button>
}
@if (isMobileView) {
  <div class="btn-sidebar">
    <button type="button" class="app-mobile-menu-button" (click)="showSidebar()" aria-label="Abrir menu">
      <i class="pi pi-bars" aria-hidden="true"></i>
    </button>
  </div>
}
@if (isMobileView && sidebarVisible) {
  <p-sidebar id="app-sidebar" styleClass="app-mobile-sidebar" appendTo="body" [(visible)]="sidebarVisible" (onHide)="onSidebarHide()" position="right" [modal]="true" [dismissible]="false">
    <p-panelMenu [model]="navMenuItems" [multiple]="false"></p-panelMenu>
  </p-sidebar>
}
